import { createSlice } from '@reduxjs/toolkit';
import { TeamsStore } from './store';
export const slice = createSlice({
    name: '@@TEAMS',
    initialState: TeamsStore.empty(),
    reducers: (create)=>({
            load: create.reducer((state)=>TeamsStore.load()(state)),
            putAll: create.reducer((state, { payload: teams })=>TeamsStore.putAll(teams)()),
            add: create.reducer((state, { payload: team })=>TeamsStore.add(team)(state)),
            remove: create.reducer((state, { payload: teamId })=>TeamsStore.remove(teamId)(state)),
            update: create.reducer((state, { payload: team })=>TeamsStore.update(team)(state))
        })
});
